// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"494ffb65","482":"a03d4fbb","498":"d794a9d0","590":"e70119a3","703":"17e7fb09"}[chunkId] + ".chunk.js";
};